import {atom} from "jotai";

export const changelogDialogStateAtom = atom(false);